// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SidenavDecoratorComponent } from './components/sidenav-decorator/sidenav-decorator.component';
import { SelectClientListModule } from '@coa/app/shared/select-client-list/select-client-list.module';
import { SidenavComponent } from './components/sidenav-decorator/sidenav/sidenav.component';
import { MatRippleModule } from '@angular/material/core';
import { HomeContentDecoratorComponent } from './components/home-content-decorator/home-content-decorator.component';
import { SelectItemsSharedModule } from '@coa/app/shared/select-items-shared/select-items-shared.module';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    TranslateModule.forChild(),
    MatButtonModule,
    FormsModule,
    DashboardModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatToolbarModule,
    SelectClientListModule,
    MatRippleModule,
    SelectItemsSharedModule,
    FeatureToggleModule,
  ],
  declarations: [
    HomeComponent,
    HomeHeaderComponent,
    SidenavDecoratorComponent,
    SidenavComponent,
    HomeContentDecoratorComponent,
  ],
})
export class HomeModule {
}
